import axios from "../helper/Axios.js";
import { adminUrl } from "../config/config.js";
import { FormatServerDate } from "./service.js";
// import { Delete, Get, Patch, Post, Put } from "./RestClient.js";

export async function getVouchers({
    code, usedBy, expiryDateType, expiryDateStart, expiryDateEnd, isRedeemed,
    page, voucherDateStart, voucherDateEnd, voucherDateType,
    redeemStartDate, redeemEndDate, redeemDateType
}) {
    try {
        let packages = await axios.Get({
            url: `${adminUrl}/voucher-list`,
            params: {
                voucherDateStart: FormatServerDate(voucherDateStart) || '',
                voucherDateEnd: voucherDateEnd || '',
                voucherDateType: voucherDateType || '',
                code: code || '',
                usedBy: usedBy || '',
                expiryDateType: expiryDateType || '',
                expiryDateStart: FormatServerDate(expiryDateStart) || '',
                expiryDateEnd: expiryDateEnd || '',
                redeemStartDate: FormatServerDate(redeemStartDate) || '',
                redeemEndDate: redeemEndDate || '',
                redeemDateType: redeemDateType || '',
                isRedeemed: isRedeemed || '',
                page: page || 0
            }
        });

        if (packages.statusCode !== 200) {
            return { error: packages.message };
        }
        return { data: packages.data };
    } catch (e) {
        return { error: e.response.data };
    }
}

export async function createVoucher(body) {
    try {
        let packages = await axios.Post({
            url: `${adminUrl}/voucher-create`,
            data: { ...body }
        });

        if (packages.statusCode !== 200) {
            return { error: packages.message };
        }

        return { data: packages.data };
    } catch (e) {
        return { error: e.response.data };
    }
}
